/* Heading underlines (bathmate-product.css, bathmate-collection.css,
   bathmate-content.css): the heading box shrinks to its text and the line
   spans it. A heading that wraps is as wide as the column, so this sets
   --bm-line-w to its widest line. Loaded on product, collection and content pages (layout/theme.liquid). */
(function () {
  'use strict';

  var SELECTOR = [
    '.product-below-content .rte > h2',
    '.pump-hx-options__heading',
    'h2[class*="ai-faq-accordion__heading-"]',
    '.size-spec-box h2',
    '.size-spec-box .size-spec-title',
    '.bm-coll-group__title',
    '.rich-text__content .rich-text__heading',
    // Content pages (bathmate-content.css).
    '.bm-content-page .section-wrapper h1:not(.headline)',
    '.bm-content-page .rte h2'
  ].join(',');

  function widestLine(el) {
    var range = document.createRange();
    range.selectNodeContents(el);
    var lines = [];
    Array.prototype.forEach.call(range.getClientRects(), function (r) {
      if (!r.width) return;
      for (var i = 0; i < lines.length; i++) {
        if (Math.abs(lines[i].top - r.top) < r.height / 2) {
          lines[i].left = Math.min(lines[i].left, r.left);
          lines[i].right = Math.max(lines[i].right, r.right);
          return;
        }
      }
      lines.push({ top: r.top, left: r.left, right: r.right });
    });
    return lines.length > 1 ? Math.max.apply(null, lines.map(function (l) { return l.right - l.left; })) : 0;
  }

  // Content pages: the first H2 of the content gets the solid line. CSS
  // marks a top-level first H2; when the first H2 sits inside a wrapper,
  // mark it, and unmark a later top-level one.
  function markFirstH2() {
    document.querySelectorAll('.bm-content-page .rte').forEach(function (root) {
      var first = root.querySelector('h2');
      if (!first) return;
      if (first.parentElement !== root) first.classList.add('bm-first-h2');
      var top = root.querySelector(':scope > h2');
      if (top && top !== first) top.classList.add('bm-not-first-h2');
    });
  }

  function update() {
    markFirstH2();
    document.querySelectorAll(SELECTOR).forEach(function (el) {
      var width = widestLine(el);
      if (width) el.style.setProperty('--bm-line-w', Math.ceil(width) + 'px');
      else el.style.removeProperty('--bm-line-w');
    });
  }

  var frame;
  function schedule() {
    window.cancelAnimationFrame(frame);
    frame = window.requestAnimationFrame(update);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
  window.addEventListener('load', schedule);
  window.addEventListener('resize', schedule);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
  document.addEventListener('shopify:section:load', schedule);
  // Headings the pump accordion script and the FAQ block add later.
  if ('MutationObserver' in window) {
    var main = document.querySelector('main') || document.body;
    new MutationObserver(schedule).observe(main, { childList: true, subtree: true });
  }
})();
